export default __webpack_public_path__ + "static/media/37-BAPA-Food-pro-Expo.0a7a3a11.jpg";